import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, [
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M16.34 11.885h-10a.68.68 0 00-.68.68v6c0 .376.304.68.68.68h10a.68.68 0 00.681-.68v-6a.68.68 0 00-.68-.68zm-10-1.32a2 2 0 00-2 2v6a2 2 0 002 2h10a2 2 0 002-2v-6a2 2 0 00-2-2h-10z",
      "clip-rule": "evenodd"
    }),
    _createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 5.75a.75.75 0 00-.75.75V12h-1.5V6.5A2.25 2.25 0 0110 4.25h4a2.25 2.25 0 012.25 2.25v2.522h-1.5V6.5a.75.75 0 00-.75-.75h-4z",
      "clip-rule": "evenodd"
    })
  ]))
}